import { useEffect, useRef, useState } from "react";

export const useActiveStepInView = (stepIds: string[]) => {
  const [activeStepId, setActiveStepId] = useState<string | null>(null);
  const nodesRef = useRef(new Map<string, HTMLDivElement>());

  const setStepRef = (stepId: string) => (node: HTMLDivElement | null) => {
    if (node) {
      nodesRef.current.set(stepId, node);
    } else {
      nodesRef.current.delete(stepId);
    }
  };

  useEffect(() => {
    const visibleRatios = new Map<string, number>();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const stepId = (entry.target as HTMLElement).dataset.stepId;
          if (stepId) {
            visibleRatios.set(stepId, entry.intersectionRatio);
          }
        });

        const [mostVisibleStepId] = [...visibleRatios.entries()].sort(
          (a, b) => b[1] - a[1]
        )[0] ?? [null];

        setActiveStepId(mostVisibleStepId);
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1] }
    );

    stepIds.forEach((stepId) => {
      const node = nodesRef.current.get(stepId);
      if (node) {
        observer.observe(node);
      }
    });

    return () => observer.disconnect();
  }, [stepIds]);

  return { activeStepId, setStepRef };
};
